var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingPg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Landing_Pg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing_Pg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "LP",
    transform: "translate(32, 25)",
    stroke: "#37474F"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.24183007,
    y1: 5.12351327,
    x2: 5.93568607,
    y2: 5.12351327,
    id: "Line-5",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2810458,
    y1: 5.12351327,
    x2: 15.9749018,
    y2: 5.12351327,
    id: "Line-5-Copy",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.5294118,
    y1: 5.12351327,
    x2: 26.2232678,
    y2: 5.12351327,
    id: "Line-5-Copy-2",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.64,
    x: 0.32,
    y: 0.32,
    width: 63.36,
    height: 63.3516351,
    rx: 5.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.744575163,
    y1: 10.351588,
    x2: 63.68,
    y2: 10.5586198,
    id: "Line",
    strokeWidth: 0.64,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.28,
    x: 3.7772549,
    y: 17.5789622,
    width: 25.7003922,
    height: 17.5410691,
    rx: 0.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.70588235,
    y1: 52.1761861,
    x2: 30.0130719,
    y2: 52.1761861,
    id: "Line-3",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.0784314,
    y1: 10.9915044,
    x2: 36.16,
    y2: 63.6716769,
    id: "Line-2",
    strokeWidth: 0.64,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.7254902,
    y1: 22.0624755,
    x2: 57.4117647,
    y2: 22.0624755,
    id: "Line-4",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.8300654,
    y1: 33.8779245,
    x2: 57.5163399,
    y2: 33.8779245,
    id: "Line-4",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.248366,
    y1: 52.2807476,
    x2: 57.9346405,
    y2: 52.2807476,
    id: "Line-4-Copy",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPg);
export default __webpack_public_path__ + "static/media/Landing_Pg.947d7b1bda48079c36d58281ce9800f9.svg";
export { ForwardRef as ReactComponent };